import update from 'immutability-helper';
import moment from "moment";

const initialState = {

    routes: [],
    ships: [],
    shipsById: {},
    fetchedRoutes: false,
    fetchingRoutes: false,
    searchFilterIds: [],
    searchParams: {},
    searching: false,
    searchComplete: false,

    userActivityHasStarted: false,

    timeline: {
        groups: [],
        items: [],
    },

    period: {
        date: moment(),
        fullMonth: true,
        type: "departure",
    }

};

Array.prototype.unique = function() {
    return this.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
};

export default (state = initialState, action)  => {

    switch (action.type){
        case "FETCH_INTERACTIVE_MAP_ROUTES":
            return update(state, {
                fetchingRoutes: {$set: true},
                fetchedRoutes: {$set: false}
            });
        case "ADD_REQUESTED_ROUTE":
            return update(state, {
                routes: {$push: [action.payload.route]}
            });
        case "START_SEARCHING":
            return update(state, {
                searchFilterIds: {$set: action.payload.routes},
                searchParams: {$set: action.payload.params},
                searching: {$set: true},
                searchComplete: {$set: false},
            });
        case "INTERACTIVE_SEARCH":
            return update(state, {
                searchFilterIds: {$set: action.payload.routes},
                searchParams: {$set: action.payload.params},
                searching: {$set: false},
                searchComplete: {$set: true},
            });
        case "CANCEL_SEARCH":

            window.location.reload();

            return update(state, {
                searchFilterIds: {$set: []},
                searchParams: {$set: {}},
                searching: {$set: true},
                searchComplete: {$set: false},
            });
        case "SET_DATE_PERIOD":
            return update(state, {
                period: {$set: action.payload},
            });
        case "USER_ACTIVITY_HAS_STARTED":
            return update(state, {
                userActivityHasStarted: {$set: true},
                // userActivityHasStarted: {$set: !state.userActivityHasStarted},
            });
        case "FETCHED_INTERACTIVE_MAP_ROUTES":

            const {routes, ships} = action.payload;

            let shipsById = {};
            for (let ship of ships){
                shipsById[ship.id] = ship;
            }

            let groups = ships.map((ship) => {
                return {id: ship.id, title: ship.name}
            });
            let items = routes.map((route, id) => {
                return {
                    id,
                    group: route.ship,
                    title: route.departure.city + " to " + route.arrival.city,
                    start_time: moment(route.departure.date),
                    end_time: moment(route.arrival.date),
                    canMove: false,
                    canResize: false,
                    canChangeGroup: false,
                    ship: route.ship,
                }
            });
            let timeline = {groups, items};

            return update(state, {
                fetchingRoutes: {$set: false},
                fetchedRoutes: {$set: true},
                routes: {$set: routes},
                ships: {$set: ships},
                shipsById: {$set: shipsById},
                timeline: {$set: timeline},
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/InteractiveMapReducer.js